export default __webpack_public_path__ + "static/media/Img0000.35c58d58.png";